<template>
  <div class="gf_plan-item">
    <div
      class="gf_plan-item__section"
      :class="{ is_recommended: isRecommended, is_current_plan: isCurrentPlan }"
    >
      <div class="gf_plan-item__section--footer">
        <div class="gf_price-footer--title" :class="{'starter-disable': planInStarter}">
          {{ liveChatTitle }}
        </div>
        <div class="gf_price-footer--desc" :class="{'starter-disable': planInStarter}" v-html="liveChatContent"></div>
      </div>
    </div>
  </div>
</template>

<script>
import promotion from "@/modules/Pricing/mixins/promotion";
import plan from "@/modules/Pricing/mixins/plan";
import planItem from "@/modules/Pricing/mixins/planItem";

export default {
  name: "RowFooterItem",
  mixins: [promotion(), plan(), planItem()],
  computed: {
    liveChatTitle() {
      if (this.planInDevelopment) {
        return this.$t("dataNewPlan.plan.title.support");
      }
      if (this.isShowPrioritySupport) {
        return this.$t("pricing.prioritySupport");
      }
      return this.liveChat ? this.$t(this.liveChat.title) : '';
    },
    liveChatContent() {
      if (this.planInDevelopment) {
        return this.$t("dataNewPlan.plan.desc.supportDev");
      }
      if (this.isAdvancePlan || this.planInEnterprise) {
        return this.$t("dataNewPlan.plan.livechat.priority.content");
      }
      return this.liveChat ? this.$t(this.liveChat.content) : '';
    }
  },
};
</script>
